module.exports = __webpack_public_path__ + "media/images/writer/monitor/sp-mv-img@2x-d517f8e2fc78b5a88fad27e3dd5c0438.png";